import React from 'react'
import NumberFormat from 'react-number-format';
import './FormInput.sass'

function FormInput(props) {
    const showIcon = props.icon
    return (
        <div key={props.keyss} className={`form__option ${props.class || ""}`}>
            <label htmlFor={props.name}>{props.title} {props.children} {props.important &&
            <span style={{color: 'red'}}>*</span>}
                {props.showAttention ? <div className="input-attention fade-in-fwd">{props.attentionText}</div> : ''}
            </label>
            {
                props.useNumberFormat ?
                    <NumberFormat
                        // onValueChange={props.isNumericString}
                        // removeFormatting={props.removeFormatting}
                        defaultValue={props.defaultValue}
                        onChange={props.onChange}
                        placeholder={props.placeholder}
                        id={props.name}
                        className="form-input"
                        name={props.name}
                        type={props.type}
                        required={props.required}
                        min={props.min}
                        minLength={props.minLength}
                        max={props.max}
                        maxLength={props.maxLength}
                        pattern={props.pattern}
                        format={props.format}
                        allowEmptyFormatting={props.allowEmptyFormatting}
                        mask={props.mask}
                        getInputRef={props.reff}
                        ref={props.reff}
                        value={props.value}
                    /> :

                    <input
                        autoComplete={'off'}
                        aria-autocomplete={'none'}
                        onBlur={props.onBlur}
                        onBlurCapture={props.onBlurCapture}
                        onFocusCapture={props.onFocusCapture}
                        onFocus={props.onFocus}
                        ref={props.reff}
                        defaultValue={props.defaultValue}
                        onChange={props.onChange}
                        placeholder={props.placeholder}
                        id={props.name}
                        className={`form-input ${props.className}`}
                        name={props.name}
                        disabled={props.disabled}
                        type={props.type}
                        required={props.required}
                        min={props.min}
                        minLength={props.minLength}
                        max={props.max}
                        maxLength={props.maxLength}
                        value={props.value}
                        pattern={props.pattern}


                    />}

            {props.hideIcon ? "" :
                <div className="input__icon">
                    {showIcon ? <i className="fas fa-check"/> : <i className="fas fa-times"/>}
                </div>}
        </div>
    )
}

export default FormInput

/*
Компонент Input предназначенный в частности для форм

Props
1) props.id : htmlFor, input id
2) props.title : Заголовок
3) props.attentionText : Текст предупреждения
4) props.onChange : Коллбэк
5) props.placeholder : input placeholder
6) props.name : input name
7) props.type : input type
8) props.icon : Передает bool для иконки
9) props.showAttention : Передает bool для предупреждения

State
1) showIcon : initial state = false
2) attention : initial state = false

 */
